import Molten from "./Molten.js";
if (typeof global !== 'undefined') {
  if (global.window === undefined) {
    global.window = global;
  }
}
export default Molten;
export { default as Constants } from "./Constants.js";
export { default as MoltenUtil } from "./MoltenUtil.js";
export * from "./roles/index.js";
export * from "./imagine/index.js";
export * from "./routes/index.js";
export * from "./startup/index.js";